import React, { useEffect, useState } from "react";
import s from "./OrderDetail.module.css";

import {
  Grid,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import ordersService from "../../../../api/delivery/ordersServices";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const OrderDetail = () => {
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState({});

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { textColor } = useSelector((state) => state.local);
  const providersRedux = useSelector((state) => state.gamma.providers);
  const gamesRedux = useSelector((state) => state.gamma.allGameOffersActive);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    ordersService
      .getOrderById(id)
      .then((res) => setOrder(res))
      .then(() => setLoading(false));
  }, []);

  return loading ? (
    <Grid container xs={12} className={s.loader}>
      <CircularProgress size={"4rem"} />
    </Grid>
  ) : (
    <Grid container className={s.container}>
      <Grid item xs={10} className={s.titleContainer}>
        <ArrowBackIcon
          sx={{ color: "primary.main", fontSize: "2.2rem" }}
          onClick={() => navigate("../ordenes-pedido")}
          className={s.arrow}
        />
        <h4>{t("details")}</h4>
      </Grid>

      <Grid container item xs={12} className={s.info}>
        <Accordion
          sx={{ width: "90%" }}
          defaultExpanded={true}
          className={s.accordion}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              backgroundColor: "primary.main",
              color: textColor,
              borderRadius: "5px 5px 0 0",
            }}
          >
            <Box className={s.summary}>
              <Typography
                className={s.titleData}
              >{`${t("orderNumber")}: ${order.id?.toString().padStart(5, "0")}`}</Typography>
              <Typography
                className={s.titleData}
              >{`${t("provider")}: ${order.supplier.businessName}`}</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Typography
                className={s.information}
              >{`${t("information")}: ${order.observations}`}</Typography>

              <TableContainer className={s.tableContainer}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("game")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("drawNumber")}/{t("serie")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("quantity")}
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {order?.detailOrdersList?.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.game.name || "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item?.raffle?.number || item?.raffle?.serie || "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }} width="15%">
                            {item.amount}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default OrderDetail;
